export enum CustomPropertyType {
	String,
	Number,
	Boolean,
	Date,
	Choice,
	ChoiceMultiselect,
	StringMultiline,
	Url
}